// @flow

import * as React from 'react';

type props = {|
  onMountMethod: any,
  children: any,
|};

class ReportIAPDefaultReason extends React.Component<props> {
  componentDidMount() {
    this.props.onMountMethod();
  }
  render() {
    return this.props.children;
  }
}

export default ReportIAPDefaultReason;
